// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"553e757b","213":"387eb62d","410":"e7522cde","455":"ba2a3187","983":"021063eb"}[chunkId] + ".chunk.js";
};